import React, { createContext, useState, useContext } from 'react';

// Create the initial context
export const CatalogContext = createContext();

// Create a provider component to wrap your application
export function CatalogContextProvider({ children }) {
  // Define the state for catalog data
  const [catalog, setCatalog] = useState(null);

  return (
    <CatalogContext.Provider value={{ catalog, setCatalog }}>
      {children}
    </CatalogContext.Provider>
  );
}

export const useCatalog = () => useContext(CatalogContext);
